'use client';

import { ForwardedRef, forwardRef, useState } from 'react';
import { motion } from 'framer-motion';
import styles from './styles.module.scss';

type InputProps = {
  label?: string;
  name?: string;
  state?: string;
  setState?: (e: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number;
  error?: any;
  type?: 'email' | 'text' | 'password' | 'number';
  children?: React.ReactNode;
  modalInput?: boolean;
};

const Input = forwardRef(
  (
    {
      label,
      name = '',
      state = '',
      setState,
      placeholder,
      style,
      className = '',
      onChange,
      maxLength,
      error,
      type = 'text',
      children,
      modalInput = false,
    }: InputProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const [focused, setFocused] = useState(false);

    const handleFocus = () => setFocused(true);
    const handleBlur = () => {
      if (!state) setFocused(false);
    };

    const hasError = error?.[name];
    const inputId = label || name;

    return (
      <>
        <div className={`${styles.root} ${className}`}>
          <div
            className={`${styles.inputRoot} ${hasError ? styles.inputError : ''}
              ${label ? styles.inputRoot : styles.inputContainer}`}
            style={style}
          >
            {label && (
              <motion.label
                layout
                initial={false}
                animate={{
                  top: focused || state ? '4px' : '20px',
                  fontSize: focused || state ? '12px' : '16px',
                  color: hasError ? '#F04438' : undefined,
                }}
                transition={{
                  duration: 0.1, // Animatsiya davomiyligi: 0.2 sekund
                  ease: 'easeInOut', // Silliq boshlanadi va tugaydi
                }}
                className={`${styles.label}`}
                htmlFor={inputId}
              >
                {label}
              </motion.label>
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <input
                ref={ref}
                id={inputId}
                type={type}
                name={name}
                value={state}
                maxLength={maxLength}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={e =>
                  onChange ? onChange(e) : setState?.(e.target.value)
                }
                placeholder={placeholder}
                className={styles.input}
                style={modalInput ? { width: '160px' } : undefined}
              />
              {children}
            </div>
          </div>
        </div>
        {/* {hasError && <p className={styles.errorText}>{hasError.message}</p>} */}
      </>
    );
  }
);

Input.displayName = 'Input';

export default Input;
